import { ApiClient } from '../client'
import { PhishingKit, ApiResponse } from '../types'

export class PhishingKitApi {
  constructor(private client: ApiClient) {}

  async list(params: {
    category?: string
    difficulty?: string
    active_only?: boolean
  } = {}): Promise<PhishingKit[]> {
    const response = await this.client.get<any>('/v1/phishing-kits', params)
    return response?.data || response || []
  }

  async get(kitId: string): Promise<PhishingKit> {
    const response = await this.client.get<any>(`/v1/phishing-kits/${kitId}`)
    return response?.data || response
  }

  async getCategories(): Promise<string[]> {
    const response = await this.client.get<any>('/v1/phishing-kits/categories')
    return response?.data || response || []
  }

  async preview(kitId: string, data: {
    organisation_id: string
    sample_target?: {
      email: string
      given_name?: string
      surname?: string
    }
  }): Promise<{
    subject: string
    html_preview: string
    text_preview: string
    landing_page_preview?: string
  }> {
    return this.client.post<any>(`/v1/phishing-kits/${kitId}/preview`, data)
  }

  // Admin endpoints
  async adminCreate(kit: Partial<PhishingKit>): Promise<ApiResponse<PhishingKit>> {
    return this.client.post<ApiResponse<PhishingKit>>('/admin/phishing-kits', kit)
  }

  async adminUpdate(kitId: string, kit: Partial<PhishingKit>): Promise<ApiResponse<PhishingKit>> {
    return this.client.patch<ApiResponse<PhishingKit>>(`/admin/phishing-kits/${kitId}`, kit)
  }

  async adminToggleActive(kitId: string, isActive: boolean): Promise<ApiResponse<PhishingKit>> {
    return this.client.patch<ApiResponse<PhishingKit>>(`/admin/phishing-kits/${kitId}/active`, { is_active: isActive })
  }

  async adminDelete(kitId: string): Promise<void> {
    return this.client.delete<void>(`/admin/phishing-kits/${kitId}`)
  }
}
